import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../services/api';
import './BlogList.css';
import banner11 from '../images/banner11.jpg';

  // Sample data for when API fails
  const samplePosts = [
    {
      id: 1,
      title: "𝗜𝘀𝗹𝗮𝗺𝗶𝗰 𝗦𝘂𝗺𝗺𝗲𝗿 𝗖𝗮𝗺𝗽",
      category: "spirituality",
      image_url: "https://i0.wp.com/irc-india.com/media/wp-content/uploads/2025/04/Islamic-Summer-Camp-2025-Poster-scaled.png?resize=2048%2C2048&ssl=1",
      excerpt: "Exploring how spiritual development helps navigate contemporary challenges...",
      date: "2024-01-15",
      read_time: "5 min read"
    },
    {
      id: 2,
      title: "IRC 10 Days Conference",
      category: "community",
      image_url: "https://i0.wp.com/irc-india.com/media/wp-content/uploads/2025/03/Ramzan-Conference-Schedule-Poster-scaled.jpg?resize=2048%2C2048&ssl=1",
      excerpt: "Historical insights on creating strong, supportive communities...",
      date: "2024-01-12",
      read_time: "7 min read"
    },
    {
      id: 3,
      title: "Certificate Distribution at ITI",
      category: "self-improvement",
      image_url: "https://i0.wp.com/irc-india.com/media/wp-content/uploads/2025/01/Certificate-Distribution-Program-Lasur-Station.png?resize=2048%2C2048&ssl=1",
      excerpt: "Simple yet powerful routines to cultivate tranquility in daily life...",
      date: "2024-01-10",
      read_time: "4 min read"
    },
    {
      id: 4,
      title: "Women Empowerment",
      category: "education",
      image_url: "https://i0.wp.com/irc-india.com/media/wp-content/uploads/2025/01/Inauguration-Of-IRC-Women-Empowerment-Centre-Parbhani-scaled.jpg?resize=2048%2C2048&ssl=1",
      excerpt: "A comprehensive guide to ethical financial practices in Islam...",
      date: "2024-01-08",
      read_time: "6 min read"
    },
    {
      id: 5,
      title: "Camps",
      category: "spirituality",
      image_url: "https://i0.wp.com/irc-india.com/media/wp-content/uploads/2025/04/Islamic-Summer-Camp-2025-Poster-scaled.png?resize=2048%2C2048&ssl=1",
      excerpt: "How expressing thankfulness transforms our spiritual journey...",
      date: "2024-01-05",
      read_time: "3 min read"
    },
    {
      id: 6,
      title: "IRC 10 Days Conferences",
      category: "community",
      image_url: "https://i0.wp.com/irc-india.com/media/wp-content/uploads/2025/03/Ramzan-Conference-Schedule-Poster-scaled.jpg?resize=2048%2C2048&ssl=1",
      excerpt: "Encouraging young Muslims to participate in meaningful social work...",
      date: "2024-01-03",
      read_time: "5 min read"
    }
  ];

const BlogFront = () => {
  const [activeCategory, setActiveCategory] = useState('all');
  const [isLoading, setIsLoading] = useState(false);
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [activeImage, setActiveImage] = useState(null);
  const [error, setError] = useState(null);
  const [usingSampleData, setUsingSampleData] = useState(false);

  useEffect(() => {
    const fetchPosts = async () => {
      setIsLoading(true);
      try {
        const data = await api.get('/blogs');
        if (data && data.length > 0) {
          setFilteredPosts(data);
          setUsingSampleData(false);
        } else {
          // If API returns empty array, use sample data
          setFilteredPosts(samplePosts);
          setUsingSampleData(true);
        }
        setIsLoading(false);
      } catch (err) {
        console.error('API Error, using sample data:', err.message);
        setError(err.message);
        setFilteredPosts(samplePosts);
        setUsingSampleData(true);
        setIsLoading(false);
      }
    };

    fetchPosts();
  }, []); // Empty dependency array is now safe

  const categories = ['all', ...new Set(filteredPosts.map(post => post.category))];

  const handleCategoryChange = (category) => {
    setIsLoading(true);
    setActiveCategory(category);

    setTimeout(() => {
      const sourceData = usingSampleData ? samplePosts : filteredPosts;
      const filtered = category === 'all'
        ? sourceData
        : sourceData.filter(post => post.category === category);
      setFilteredPosts(filtered);
      setIsLoading(false);
    }, 300);
  };

  const closeLightbox = () => {
    setActiveImage(null);
  };

  const handleReload = () => {
    window.scrollTo(0, 0);
  };

  if (error && filteredPosts.length === 0) {
    return (
      <div className="error">
        <div>Error: {error}</div>
        <div style={{marginTop: '10px', fontSize: '0.9rem', color: '#666'}}>
          Showing sample data for demonstration.
        </div>
      </div>
    );
  }

  return (
    <section className="gallery-section">
      <div className="gallery-container">
        <div className="media-header">
          <h2 className="gallery-title">Our Latest News & Blogs</h2>
          <Link to="/bloglist" className="activities-button" onClick={handleReload}>
            View All
          </Link>
        </div>
        <p className="gallery-subtitle">
          Catch a glimpse of our activities and lectures - working humbly towards spreading the Message of Peace, Alhamdulillaah.
          {usingSampleData && (
            <span style={{display: 'block', marginTop: '10px', fontStyle: 'italic', color: '#e8252d'}}>
              Currently showing sample data
            </span>
          )}
        </p>

        {/* Category Filters */}
        <div className="gallery-filters">
          {categories.map(category => (
            <button
              key={category}
              className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
              onClick={() => handleCategoryChange(category)}
              disabled={isLoading}
            >
              {category.charAt(0).toUpperCase() + category.slice(1)}
            </button>
          ))}
        </div>

        {/* Loading Overlay */}
        <div className="gallery-grid-container">
          {isLoading ? (
            <div className="grid-loading-spinner">
              <div className="loading-spinner"></div>
            </div>
          ) : (
            <>
              {filteredPosts.length === 0 ? (
                <div className="empty-state">
                  <h3>No blog posts found</h3>
                  <p>There are currently no blog posts available in this category.</p>
                </div>
              ) : (
                <div className="gallery-grid">
                  {filteredPosts.map(post => (
                    <Link 
                      to={`/blog/${post.id}`} 
                      key={post.id} 
                      className="gallery-item-link"
                    >
                      <div className="gallery-item">
                        <img
                          src={post.image_url || banner11}
                          alt={post.title}
                          className="gallery-image"
                          loading="lazy"
                        />
                        <div className="image-overlay">
                          <span className="image-caption">{post.title}</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              )}
            </>
          )}
        </div>

        {/* Lightbox */}
        {activeImage && (
          <div className="lightbox" onClick={closeLightbox}>
            <div className="lightbox-content" onClick={e => e.stopPropagation()}>
              <button className="close-btn" onClick={closeLightbox}>&times;</button>
              <img
                src={activeImage.image_url || banner11}
                alt={activeImage.title}
                className="lightbox-image"
              />
              <div className="lightbox-caption">{activeImage.title}</div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default BlogFront;



















// import React, { useState, useEffect } from 'react';
// import { Link } from 'react-router-dom';
// import api from '../services/api';
// import './BlogList.css';
// import banner11 from '../images/banner11.jpg';

// const BlogFront = () => {
//   const [activeCategory, setActiveCategory] = useState('all');
//   const [isLoading, setIsLoading] = useState(false);
//   const [filteredPosts, setFilteredPosts] = useState([]);
//   const [activeImage, setActiveImage] = useState(null);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchPosts = async () => {
//       setIsLoading(true);
//       try {
//         const data = await api.get('/blogs');
//         setFilteredPosts(data);
//         setIsLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setIsLoading(false);
//       }
//     };

//     fetchPosts();
//   }, []);

//   const categories = ['all', ...new Set(filteredPosts.map(post => post.category))];

//   const handleCategoryChange = (category) => {
//     setIsLoading(true);
//     setActiveCategory(category);

//     setTimeout(() => {
//       const filtered = category === 'all'
//         ? filteredPosts
//         : filteredPosts.filter(post => post.category === category);
//       setFilteredPosts(filtered);
//       setIsLoading(false);
//     }, 300);
//   };

//   const closeLightbox = () => {
//     setActiveImage(null);
//   };

//   const handleReload = () => {
//     window.scrollTo(0, 0);
//   };

//   if (error) return <div className="error">Error: {error}</div>;

//   return (
//     <section className="gallery-section">
//       <div className="gallery-container">
//         <div className="media-header">
//           <h2 className="gallery-title">Our Latest News & Blogs</h2>
//           <Link to="/bloglist" className="activities-button" onClick={handleReload}>
//             View All
//           </Link>
//         </div>
//         <p className="gallery-subtitle">
//           Catch a glimpse of our activities and lectures - working humbly towards spreading the Message of Peace, Alhamdulillaah.
//         </p>

//         {/* Category Filters */}
//         <div className="gallery-filters">
//           {categories.map(category => (
//             <button
//               key={category}
//               className={`filter-btn ${activeCategory === category ? 'active' : ''}`}
//               onClick={() => handleCategoryChange(category)}
//               disabled={isLoading}
//             >
//               {category.charAt(0).toUpperCase() + category.slice(1)}
//             </button>
//           ))}
//         </div>

//         {/* Loading Overlay */}
//         <div className="gallery-grid-container">
//           {isLoading ? (
//             <div className="grid-loading-spinner">
//               <div className="loading-spinner"></div>
//             </div>
//           ) : (
//             <div className="gallery-grid">
//               {filteredPosts.map(post => (
//                 <Link 
//                   to={`/blog/${post.id}`} 
//                   key={post.id} 
//                   className="gallery-item-link"
//                 >
//                   <div className="gallery-item">
//                     <img
//                       src={post.image_url || banner11}
//                       alt={post.title}
//                       className="gallery-image"
//                       loading="lazy"
//                     />
//                     <div className="image-overlay">
//                       <span className="image-caption">{post.title}</span>
//                     </div>
//                   </div>
//                 </Link>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Lightbox */}
//         {activeImage && (
//           <div className="lightbox" onClick={closeLightbox}>
//             <div className="lightbox-content" onClick={e => e.stopPropagation()}>
//               <button className="close-btn" onClick={closeLightbox}>&times;</button>
//               <img
//                 src={activeImage.image_url || banner11}
//                 alt={activeImage.title}
//                 className="lightbox-image"
//               />
//               <div className="lightbox-caption">{activeImage.title}</div>
//             </div>
//           </div>
//         )}
//       </div>
//     </section>
//   );
// };

// export default BlogFront;